export default "__VITE_ASSET__wQP3nGW9__"